import { SxProp } from 'src/types/mui';

export const avatarWrapperStyles: SxProp = {
  display: 'grid',
  gridGap: '10px',
};

export const avatarStyles: SxProp = {
  width: '100%',
  maxWidth: '100px',
  height: '100%',
  maxHeight: '100px',
};
